import React from 'react'
// import VideoModal from '../ModalVideo/VideoModal'
// import { Link } from 'react-router-dom'
// import CountUp from 'react-countup'
// import abImg from '../../images/about/about-1/1.jpg'
import abImg3 from '../../images/about/about-1/3.jpg'
import RollingText from '../RollingText/RollingText'

const AboutMission = (props) => {
  const ClickHandler = () => {
    window.scrollTo(0, 0)
  }

  return (
    <section id="about" className={'' + props.hclass}>
      <div className="about-wrap-mission container">
        <div className="about-content-mission">
          <div className="content-mission">
            <h2
              className="scroll-text-animation"
              data-animation="fade_from_right"
            >
              Vision
            </h2>
            <p className="fade_bottom">
              To shape the future of community by pioneering excellence in
              architecture, construction, contracting, and investment, building
              enduring structures that stand the test of time.
            </p>
            <h2
              className="scroll-text-animation"
              data-animation="fade_from_right"
            >
              Mission
            </h2>
            <p className="fade_bottom">
              A to Z Construction Group has been dedicated to turning visionary
              ideas into remarkable realities. Our mission is to lead in
              architecture, construction, contracting, and investment by
              delivering innovative designs, robust project execution, and
              sustainable developments. Through meticulous planning and
              strategic investment, we transform concepts into structures that
              define skylines and inspire communities.
            </p>
          </div>
        </div>
      </div>
       <div className="break-who"></div>
      <div className="about-section-who container">
        <div className="content-who">
          <h2
            className="scroll-text-animation"
            data-animation="fade_from_right"
          >
            Who We Are?
          </h2>
          <p className="fade_bottom">
            The roots of our foundation dates back for almost two decades, A to
            Z Construction Company is a cornerstone of growth and innovation in
            Iraq’s construction sector. With expertise spanning architecture,
            contracting, and investment, we have consistently set new standards
            for quality and reliability.
          </p>
          <p className="fade_bottom">
            At A to Z, we don’t just build structures; we create lasting value.
            Our integrated approach covers every phase of developmentfrom
            architectural design and project supervision to construction and
            strategic investment. This seamless process ensures that each
            project is exec.
          </p>
          <p className="fade_bottom">
            Backed by a legacy of trust and a forward-thinking mindset, A to Z
            Construction Company is committed to elevating infrastructure across
            Iraq, contributing to both urban expansion and economic progress.
            Our projects are a testament to our craftsmanship, innovation, and
            unwavering commitment to excellence.
          </p>
        </div>
       
        <div>
          <div className="image ">
            <div className="image-2 poort-in-right">
              <img className="img-about " src={abImg3} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutMission
